/** Import modules */

import React                from 'react';

import { createRoot }       from 'react-dom/client';

import { ApolloProvider }   from "@apollo/client";

import { HelmetProvider }   from "react-helmet-async";

import { Helmet }           from 'react-helmet-async';

/** Import configurations */

import Apollo               from './Configs/Apollo';

import Languages            from './Configs/Languages';

/** Import components */

import Application          from './Pages/Application';

import { SEO_ORIGIN }       from './Components/SEO/localizedMeta';

/** Import styles */

import 'swiper/css';

import "./Styles/Main.css";

import "./Styles/Mobile.css";

/** Initialize i18n languages */

Languages ();

/** Render application */

const seoStaticPreview = document.getElementById ( 'seo-static-preview' );

if ( seoStaticPreview ) seoStaticPreview.remove ();

createRoot ( document.getElementById ( 'b2c-tireshop' ) ).render (

  <HelmetProvider>

    <Helmet defer={ false }>

        <title>{ `Tireshop.lv` }</title>

      <meta
        name="description"
        content="Tireshop.lv lielākais riepu centrs un serviss ar vairāk kā 30 000 riepu un disku, akumulatoru klāstu uz vietas. Labas cenas, plašs klāsts, ātrs serviss."
      />

        <link rel="canonical" href={`${ SEO_ORIGIN }/`} />

    </Helmet>

    <ApolloProvider client={ Apollo }>

      <Application />

    </ApolloProvider>

  </HelmetProvider>

);
